/**
 * DEPLOYDAN KEYINGI ESKI SAHIFA (egasi, 22.10.2026: "client oynasiga endi umuman o'tmay qoldi").
 *
 * Sahifalar (marshrutlar) alohida JS bo'laklarida (`/js/4538.<hash>.js`) yuklanadi. Deploy yangi bo'laklarni
 * boshqa nom bilan chiqaradi, eskilari o'chadi. Deploydan OLDIN ochilgan tab esa eski nomni so'raydi -> 404 ->
 * marshrut jimgina ochilmaydi (production 22.10 18:09 UTC: `4538.7d3b0b61.js` — mijoz kartasi, 19 marta 404).
 * Yechim: shunday xatoda maqsad manzil TO'LIQ qayta yuklanadi (yangi index.html + yangi bo'laklar).
 * Cheksiz aylanmasin: bir manzilga `QAYTA_MS` ichida faqat bir marta.
 */

export const BOLAK_XATOSI = /Loading (CSS )?chunk [\w-]+ failed|ChunkLoadError|Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i

export const QAYTA_MS = 10000
export const KALIT = 'oasis_bolak_qayta'

/** Xato — yuklanmagan JS / CSS bo'lagi (deploydan keyingi eski tab)mi. */
export function bolakXatosimi(xato) {
  if (!xato) return false
  return BOLAK_XATOSI.test(`${xato.name || ''} ${xato.message || xato}`)
}

/**
 * Qayta yuklash kerakmi: bir manzilga `QAYTA_MS` ichida takror bo'lsa — YO'Q (aylanma). Holat `saqlagich` da
 * (sessionStorage). Saqlagich ishlamasa ham bir marta urinadi.
 */
export function qaytaYuklashKerakmi(manzil, saqlagich, hozir = Date.now()) {
  try {
    const oldingi = JSON.parse(saqlagich.getItem(KALIT) || 'null')
    if (oldingi && oldingi.yol === manzil && hozir - oldingi.vaqt < QAYTA_MS) return false
    saqlagich.setItem(KALIT, JSON.stringify({ yol: manzil, vaqt: hozir }))
  } catch {
    /* xususiy oyna / bloklangan saqlagich — baribir bir marta */
  }
  return true
}
